import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/Authentication/App'
import { Provider } from 'react-redux'
import ReduxStore from './Redux/Store'
import 'bootstrap/dist/css/bootstrap.min.css'
import './main.css'

ReactDOM.render(
  <Provider store={ReduxStore}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
)
